import { Space, Typography } from 'antd';

import { ContentWrapper } from '@/components/_common';
import { flatInfiniteData } from '@/utils/request/flatInfiniteData';
import InfiniteTable, { ColumnsType } from '@/components/_common/InfiniteTable';
import { COLUMNS_WIDTH, getTableScrollX } from '@/utils/table';
import { useInformatives } from '@/core/domain/notification/Informative/Informative.hooks';
import { Informative } from '@/core/domain/notification/Informative/Informative.types';
import EyeIcon from '@/components/_common/EyeIcon';
import ViewInformativeModal from './ViewInformativeModal';
import { useState } from 'react';
import { useDisclosure } from '@/hooks';
import moment from 'moment';
import Authorities from '@/types/Authority';
import { hasPermissions } from '@/utils/functions/hasPermissions';

const { Title } = Typography;

function HomeInformatives() {
  const { data, isFetching } = useInformatives(
    { rows: 6, order: 'DESC' },
    hasPermissions([Authorities.DEFAULT_INFORMATIVE]),
  );

  const informatives = flatInfiniteData(data);

  const [informative, setInformative] = useState<Informative>();

  const [openVisible, openVisibleAction] = useDisclosure();

  const handleViewInformative = (informative: Informative) => {
    setInformative(informative);

    openVisibleAction.open();
  };

  const columns: ColumnsType<Informative> = [
    {
      dataIndex: 'employeeName',
      width: COLUMNS_WIDTH.default,
      ellipsis: true,
      render: (value) => `De: ${value}`,
    },
    {
      dataIndex: 'message',
      width: COLUMNS_WIDTH.default,
      ellipsis: true,
    },
    {
      dataIndex: 'actions',
      width: 50,
      fixed: 'right',
      align: 'right',
      render: (_, record) => (
        <EyeIcon iconProps={{ onClick: () => handleViewInformative(record) }} />
      ),
    },
  ];

  return (
    <>
      <ContentWrapper
        style={{
          height: '360px',
          padding: 24,
        }}
      >
        <Space size="large">
          <Title level={4} style={{ margin: 0 }}>
            Informativos (Últimos 7 dias)
          </Title>
        </Space>

        <InfiniteTable
          columns={columns}
          dataSource={informatives.filter(
            (informative) =>
              moment(informative.informationDate) > moment().subtract(7, 'day'),
          )}
          loading={isFetching}
          showHeader={false}
          rowKey={(row) => row.id}
          scroll={{ x: getTableScrollX(columns) }}
        />
      </ContentWrapper>

      <ViewInformativeModal
        informative={informative}
        open={openVisible}
        onCancel={openVisibleAction.close}
      />
    </>
  );
}

export default HomeInformatives;
